import * as React from 'react';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {Button} from 'shells/button/button';

import {ImportUnsubscribesOnboardingModal} from './import-unsubscribes-onboarding-modal';

type OwnProps = {
    isDisabled?: boolean;
    onClick: () => void;
    children: React.ReactNode;
};

type Props = OwnProps & ContextRouter;

export function EditButtonRouted(props: Props) {
    const [
        shouldShowImportUnsubscribesOnboardingModal,
        setShouldShowImportUnsubscribesOnboardingModal,
    ] = React.useState<boolean>(false);
    const [shouldWiggle, setShouldWiggle] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (NutClientConfig.shouldShowImportUnsubscribesOnboardingModal) {
            // Need a slight delay or its a bit jarring
            setTimeout(() => {
                setShouldShowImportUnsubscribesOnboardingModal(true);
                // Clear this jank local state
                delete NutClientConfig.shouldShowImportUnsubscribesOnboardingModal;

                // Wiggle the button for flair
                setShouldWiggle(true);
            }, 1000);
        }
    }, []);

    const handleClose = () => {
        setShouldShowImportUnsubscribesOnboardingModal(false);
    };

    return (
        <React.Fragment>
            <Button
                id='edit-button'
                size='big'
                disabled={props.isDisabled}
                wiggle={shouldWiggle}
                onClick={props.onClick}
            >
                {props.children}
            </Button>
            {shouldShowImportUnsubscribesOnboardingModal ? (
                <ImportUnsubscribesOnboardingModal onClose={handleClose} />
            ) : undefined}
        </React.Fragment>
    );
}

// @ts-expect-error
export const EditButton = withRouter<OwnProps>(EditButtonRouted);
